import { splitByProgress } from '../utils/karaoke';

/**
 * 音声プレビュー中の「カラオケ風」文面表示 — Issue #643。
 *
 * 再生進捗 (`progress`: 0〜1) に応じて、読み上げ済みの部分をハイライトする。
 * 進捗は「文字数の割合 = 再生時間の割合」の近似であり、厳密な発話位置ではない。
 */
export function KaraokeText({
  text,
  progress,
  label,
  testId = 'karaoke-text',
}: {
  /** 表示する文面 (プレーンテキスト)。空のときは label のみ表示する */
  text: string;
  /** 再生進捗 (0〜1) */
  progress: number;
  /** 再生中の要素の表示名 (例: 「開始チャイム」「#1 自列車遅延 (ja)」) */
  label?: string;
  /** `data-testid` (既定: karaoke-text) */
  testId?: string;
}): React.JSX.Element {
  const { done, rest } = splitByProgress(text, progress);
  return (
    <div
      className="karaoke-text"
      data-testid={testId}
      style={{
        margin: '6px 0',
        padding: '8px 10px',
        border: '1px solid #d0d7de',
        borderRadius: 4,
        background: '#f6f8fa',
        lineHeight: 1.7,
      }}
    >
      {label ? (
        <div className="hint" data-testid={`${testId}-label`}>
          ▶ 再生中: {label}
        </div>
      ) : null}
      {text ? (
        <div data-testid={`${testId}-body`}>
          <span
            data-testid={`${testId}-done`}
            style={{ color: '#0969da', fontWeight: 'bold', background: '#ddf4ff' }}
          >
            {done}
          </span>
          <span data-testid={`${testId}-rest`}>{rest}</span>
        </div>
      ) : null}
    </div>
  );
}
